export function getBuiltAttributes(
  extraData,
  recordBody
) {
  Object.keys(extraData).forEach(key => {
    // eslint-disable-next-line security/detect-object-injection
    if (key in recordBody.attributes) recordBody.attributes[key] = extraData[key]
  })
  return recordBody
}
